export const CB = 'CB';
export const GOOGLE_PAY = 'GOOGLEPAY';
export const APPLE_PAY = 'APPLEPAY';
export const PAYPAL = 'PAYPAL';
export const ENTERPRISE_CARD = 'ENTERPRISE_CARD';

export const FORCE_CB_PAYMENT = true;



// WEBPACK FOOTER //
// ./src/constants/paymentMethods.js